// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -187090289
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';
import { Address } from '../../models/providergroup/address';
import { Contact } from '../../models/providergroup/contact';
import { Document } from '../../models/providergroup/document';

export class ProviderGroup {
  @Required()
  providerGroupId: string;
  companyId: string;
  metroAreaId: number;
  statusId: number;
  @StringLength(255)
  email: string;
  @StringLength(255)
  fax: string;
  loadTime: Date | string;
  @StringLength(256)
  name: string;
  @StringLength(2000)
  notes: string;
  @StringLength(255)
  npi: string;
  @StringLength(50)
  phone: string;
  @StringLength(16)
  tin: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  addresses: Address[];
  contacts: Contact[];
  documents: Document[];
}

export function initializeNewProviderGroup(): ProviderGroup {
  const instance = new ProviderGroup();
  instance.providerGroupId = '00000000-0000-0000-0000-000000000000';
  instance.companyId = '00000000-0000-0000-0000-000000000000';
  instance.metroAreaId = null;
  instance.statusId = null;
  instance.email = '';
  instance.fax = '';
  instance.loadTime = null;
  instance.name = '';
  instance.notes = '';
  instance.npi = '';
  instance.phone = '';
  instance.tin = '';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.addresses = null;
  instance.contacts = null;
  instance.documents = null;
  return instance;
}
